function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { BrickContext } from "./BrickContext";
import { BrickDependencyCollector } from "./BrickDependencyCollector";
/**
 * Encapsulates brick activation lifecycle and configuration.
 *
 * If BrickLevels is specified, it should be a union of strings. Bricks activated by this BrickManager can specify
 * an optional `static level` that is one of the specified levels. This is used to validate brick dependencies;
 * see _levelDependencyValidator.
 */ export var BrickManager = /*#__PURE__*/ function() {
    "use strict";
    function BrickManager(levelDependencyValidator) {
        _class_call_check(this, BrickManager);
        /**
   * List of active brick entries. Deactivated brick entries are removed from the list.
   * Marked `protected` for use in unit tests only.
   */ _define_property(this, "_activeBrickEntries", new Map());
        _define_property(this, "_brickDependencyCollector", void 0);
        _define_property(this, "_brickContextFactory", void 0);
        // BrickConstructor dependencies (no BrickRegistry lookup)
        var getDependencies = function(brickConstructor) {
            var _brickConstructor_dependencies;
            return (_brickConstructor_dependencies = brickConstructor.dependencies) !== null && _brickConstructor_dependencies !== void 0 ? _brickConstructor_dependencies : [];
        };
        this._brickDependencyCollector = new BrickDependencyCollector(getDependencies, levelDependencyValidator);
    }
    _create_class(BrickManager, [
        {
            /**
   * Check if a given brick is active or activating.
   * @param brickId - Brick ID
   * @returns True if brick is active/activating.
   */ key: "isBrickActive",
            value: function isBrickActive(brickId) {
                return this._activeBrickEntries.has(brickId);
            }
        },
        {
            key: "activateBrick",
            value: /**
   * Activate a Horizon brick. If the brick has a static `dependencies`
   * property, also activates all those dependencies recursively. Each
   * dependent brick is only activated once, even if it is a dependency
   * of multiple ohter bricks.
   *
   * Do not call `activateBrick()` directly from another brick's
   * activation (synchronously or asynchronously). Use `dependencies`
   * instead.
   *
   * Note that we can't assume TypeScript type checking here where we might
   * consume code outside of our repository.
   *
   * Does not construct or activate the brick if its required requiredFlags or
   * requiredDraftModels are not enabled. Returns undefined in this case.
   *
   * If the brick has already been activated, does nothing.
   *
   * @param locator - Locator whose map meets the brick's dependencies
   * @param brickConstructor - the brick's class name, e.g. `class MyBrick ...` then
   *   brickManager.activateBrick(locator, MyBrick);
   */ function activateBrick(locator, brickConstructor) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this__activeBrickEntries_get;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.activateBricks(locator, [
                                        brickConstructor
                                    ])
                                ];
                            case 1:
                                _state.sent();
                                //@ts-ignore
                                return [
                                    2,
                                    (_this__activeBrickEntries_get = _this._activeBrickEntries.get(brickConstructor.id)) === null || _this__activeBrickEntries_get === void 0 ? void 0 : _this__activeBrickEntries_get.brick
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_activateBrickWithoutDependencies",
            value: /**
   * Activate a single brick constructor without recursing into its dependencies.
   * @param locator - Locator whose map meets the brick's dependencies
   * @param brickConstructor - the brick's class name
   * @param allFeatureFlags - the set of feature flags present in the app configuration.
   * @returns the activated brick.
   */ function _activateBrickWithoutDependencies(locator, brickConstructor) {
                var _this = this;
                return _async_to_generator(function() {
                    var brickId, brick;
                    return _ts_generator(this, function(_state) {
                        brickId = brickConstructor.id;
                        //@ts-ignore
                        _this._validateActivatingBrickId(brickConstructor);
                        // Don't reactivate this brick if it's already been activated. This can happen if multiple bricks
                        // declare this as a dependency. Note that there can be no async breaks (awaits) between this test
                        // and the call to _activateBrick() below (which synchronously adds the brick entry to
                        // _activeBrickEntries).
                        if (_this._activeBrickEntries.has(brickId)) {
                            return [
                                2,
                                undefined
                            ];
                        }
                        brick = _this._createBrickInstance(brickConstructor);
                        return [
                            2,
                            _this._activateBrickInstance(locator, brick, brickId)
                        ];
                    });
                })();
            }
        },
        {
            key: "_activateBrickInstance",
            value: /**
   * Activate a single brick instance without recursing into its dependencies.
   * @param locator - Locator whose map meets the brick's dependencies
   * @param brick - the brick instance (not constructor)
   * @param brickId - the brick id
   * @returns the activated brick.
   */ function _activateBrickInstance(locator, brick, brickId) {
                var _this = this;
                return _async_to_generator(function() {
                    var context, deactivator, brickConstructor;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Provide a unique context per brick.
                                context = _this._createBrickContext(locator);
                                // Pre-create a brick deactivator function
                                deactivator = _this._createBrickDeactivator(brickId);
                                // activate the brick and store it alongside the context and deactivator
                                brickConstructor = brick.constructor;
                                return [
                                    4,
                                    _this._activateBrick(brickId, //@ts-ignore
                                    {
                                        brickConstructor: brickConstructor,
                                        brick: brick,
                                        context: context
                                    }, deactivator)
                                ];
                            case 1:
                                _state.sent();
                                // return the brick instance
                                return [
                                    2,
                                    brick
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "collectBricksAndDependencies",
            value: /**
   * Map from an array of brick constructors to an array inclusive of the input array and all dependencies.
   *
   * @param constructorArray - Array of BrickConstructor
   * @returns Array of BrickConstructor containing the input constructorArray and all dependencies.
   * @throws if BrickLevelDependencyValidator fails
   */ function collectBricksAndDependencies(constructorArray) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            _this._brickDependencyCollector.collectBricksAndDependencies(constructorArray)
                        ];
                    });
                })();
            }
        },
        {
            key: "activateBricks",
            value: /**
   * Async activate Horizon bricks in parallel. See activateBrick() for what happens with each brick.
   *
   * @param locator - Locator whose map meets every brick's dependencies
   * @param constructorArray - Array of BrickConstructor
   */ function activateBricks(locator, constructorArray) {
                var _this = this;
                return _async_to_generator(function() {
                    var brickAndDependencies;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.collectBricksAndDependencies(constructorArray)
                                ];
                            case 1:
                                brickAndDependencies = _state.sent();
                                return [
                                    2,
                                    _this._activateBricks(locator, brickAndDependencies)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "activateBricksUsingPrecomputedDependencies",
            value: /**
   * Async activate Horizon bricks in parallel without computing dependencies. See activateBrick() for what happens with each brick.
   * Assumes that BrickManager#mapBricksWithDependencies() was called and the results provided as the constructorArray argument.
   *
   * @param locator - Locator whose map meets every brick's dependencies
   * @param bricksAndDependencies - Array of BrickConstructor
   */ function activateBricksUsingPrecomputedDependencies(locator, bricksAndDependencies) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            _this._activateBricks(locator, bricksAndDependencies)
                        ];
                    });
                })();
            }
        },
        {
            key: "_activateBricks",
            value: /**
   * Async activate Horizon bricks in parallel without computing dependencies. See activateBrick() for what happens with each brick.
   *
   * @param locator - Locator whose map meets every brick's dependencies
   * @param constructorArray - Array of BrickConstructor
   */ function _activateBricks(locator, constructorArray) {
                var _this = this;
                return _async_to_generator(function() {
                    var bricks;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(constructorArray.map(function(brickConstructor) {
                                        return _this._activateBrickWithoutDependencies(locator, brickConstructor);
                                    }))
                                ];
                            case 1:
                                bricks = _state.sent();
                                return [
                                    2,
                                    bricks
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_validateActivatingBrickId",
            value: /**
   * Validates prerequisites for brick activation.
   *
   * @param brickId - the brick id
   */ function _validateActivatingBrickId(brickConstructor) {
                // Check for invalid brick id
                var brickId = brickConstructor.id;
                if (!brickId) {
                    throw new Error("Missing brick id property");
                }
                if (this._activeBrickEntries.has(brickId)) {
                    var entry = this._activeBrickEntries.get(brickId);
                    // Check for whether we're trying to activate a different constructor with the same brick ID.
                    if (entry.brickConstructor !== brickConstructor) {
                        throw new Error('Brick with ID "'.concat(brickId, '" was already activated with a different constructor'));
                    }
                }
                // Check for bad input
                if (typeof brickConstructor !== "function") {
                    throw new Error('Brick with ID "'.concat(brickId, '" is not a constructor'));
                }
                // Check for flag requirements incorrectly specified as non-static
                if (brickConstructor.prototype.requiredFlags || brickConstructor.prototype.requiredDraftModels) {
                    throw new Error('Brick with ID "'.concat(brickId, '" must specify requiredFlags and/or requiredDraftModels as static fields, not instance members'));
                }
            }
        },
        {
            key: "_createBrickInstance",
            value: /**
   * Creates a brick instance.
   *
   * @param brickConstructor - the brick's class name
   * @returns a brick instance
   */ function _createBrickInstance(brickConstructor) {
                var brick;
                try {
                    // eslint-disable-next-line new-cap -- constructor is passed in as a variable
                    brick = new brickConstructor();
                } catch (error) {
                    throw new Error('TypeError: Brick with ID "'.concat(brickConstructor.id, '" threw an exception'));
                }
                if (typeof brick.onActivate !== "function") {
                    throw new Error('Brick with ID "'.concat(brickConstructor.id, '" is missing the activate lifecycle method'));
                }
                return brick;
            }
        },
        {
            key: "_activateBrick",
            value: /**
   * Activates a pre-created brick instance and stores it together with the context and the deactivator in
   * the internal active bricks map.
   *
   * @param brickId - the Brick id
   * @param brickEntry - the Brick entry to store in the internal active bricks map
   * @param deactivator - the Brick deactivator function
   */ function _activateBrick(brickId, brickEntry, deactivator) {
                var _this = this;
                return _async_to_generator(function() {
                    var brick, context, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Store the brick entry in the active bricks map just before activation, to prevent going into infinite
                                // circular activation loops.
                                _this._activeBrickEntries.set(brickId, brickEntry);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                brick = brickEntry.brick, context = brickEntry.context;
                                return [
                                    4,
                                    brick.onActivate(context, deactivator)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                // if activation fails, remove the brick entry from the active bricks map.
                                _this._activeBrickEntries.delete(brickId);
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Override the default {@link BrickContext} factory
   * @param factory - A {@link BrickContext} factory
   */ key: "setBrickContextFactory",
            value: function setBrickContextFactory(factory) {
                this._brickContextFactory = factory;
            }
        },
        {
            key: "_createBrickContext",
            value: /**
   * Creates and returns a brick context.
   */ function _createBrickContext(locator) {
                if (this._brickContextFactory === undefined) {
                    return new BrickContext(locator);
                }
                return this._brickContextFactory(locator);
            }
        },
        {
            key: "_createBrickDeactivator",
            value: /**
   * Creates a brick deactivator function.
   *
   * @param brickId - the brick id
   * @returns A brick deactivator function
   */ function _createBrickDeactivator(brickId) {
                var _this = this;
                return /*#__PURE__*/ _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            _this._deactivateBrick(brickId)
                        ];
                    });
                });
            }
        },
        {
            key: "_deactivateBrick",
            value: function _deactivateBrick(brickId) {
                var _this = this;
                return _async_to_generator(function() {
                    var _brick_onDeactivate, entry, brick, context;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                entry = _this._activeBrickEntries.get(brickId);
                                if (!entry) {
                                    throw new Error('BrickDeactivation: Brick "'.concat(brickId, '" is not active.'));
                                }
                                brick = entry.brick, context = entry.context;
                                return [
                                    4,
                                    (_brick_onDeactivate = brick.onDeactivate) === null || _brick_onDeactivate === void 0 ? void 0 : _brick_onDeactivate.call(brick, context)
                                ];
                            case 1:
                                _state.sent();
                                _this._activeBrickEntries.delete(brickId);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deactivateBricks",
            value: /**
   * Deactivate Horizon bricks which were activated by the brick manager, but sequentially and in the reverse order of
   * their activation. This is done to address the potential dependencies between bricks when performing a clean
   * editor shutdown.
   */ function deactivateBricks() {
                var _this = this;
                return _async_to_generator(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, brickId, err;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = _to_consumable_array(_this._activeBrickEntries.keys()).reverse()[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                brickId = _step.value;
                                // eslint-disable-next-line no-await-in-loop -- see comment above
                                return [
                                    4,
                                    _this._deactivateBrick(brickId)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadDynamicBricks",
            value: /**
   * Async load dynamic brick URLs and activate in parallel.
   */ function loadDynamicBricks(locator, dynamicBrickUrls) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!dynamicBrickUrls) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    Promise.all(dynamicBrickUrls.map(/*#__PURE__*/ function() {
                                        var _ref = _async_to_generator(function(url) {
                                            var brickModule;
                                            return _ts_generator(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            import(/* @vite-ignore */ url)
                                                        ];
                                                    case 1:
                                                        brickModule = _state.sent();
                                                        return [
                                                            2,
                                                            _this.activateBrick(locator, brickModule.default)
                                                        ];
                                                }
                                            });
                                        });
                                        return function(url) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "activeBrickIds",
            get: /**
   * Array containing all activated brick IDs. Used in unit tests only.
   */ function get() {
                return Array.from(this._activeBrickEntries.keys()).sort();
            }
        }
    ]);
    return BrickManager;
}();

//# sourceMappingURL=BrickManager.js.map